<template>
  <div class="project-installation">
    <div class="accordion" role="tablist">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-installation-rough-planning
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-calendar mr-2"></i>{{ $t('roughPlanning') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse id="project-installation-rough-planning" role="tabpanel">
          <div class="accordion-content px-2 py-2">
            <ProjectRoughPlanning :project="project" />
          </div>
        </b-collapse>
      </div>
    </div>

    <div class="accordion" role="tablist">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-installation-appointments
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-calendar-check-o mr-2"></i>{{ $t('installationAppointments') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse id="project-installation-appointments" role="tabpanel" visible>
          <div class="accordion-content px-2 py-2">
            <ProjectAppointments ref="projectAppointments" :project="project" />
          </div>
        </b-collapse>
      </div>
    </div>

    <div v-if="showAppointmentCapacitySlots" class="accordion" role="tablist">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-installation-appointment-capacities
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-calendar-plus-o mr-2"></i>{{ $t('appointmentCapacities') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse id="project-installation-appointment-capacities" role="tabpanel">
          <div class="accordion-content px-2 py-2">
            <ProjectAppointmentCapacities
              ref="projectAppointmentCapacities"
              :project="project"
              @booked="onAppointmentCapacityBooked"
            />
          </div>
        </b-collapse>
      </div>
    </div>

    <div class="accordion" role="tablist">
      <div class="mb-3">
        <b-button
          block
          v-b-toggle.project-installation-time-tracking
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-clock-o mr-2"></i>{{ $t('time_tracking') }}
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse id="project-installation-time-tracking" role="tabpanel">
          <div class="accordion-content px-2 py-2">
            <TimeTrackingTable :project="project" />
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TimeTrackingTable from '@/components/TimeTrackingTable';
import ProjectRoughPlanning from '@/views/Projects/ProjectRoughPlanning';
import ProjectAppointments from '@/views/Projects/ProjectAppointments';
import ProjectAppointmentCapacities from '@/views/Projects/ProjectAppointmentCapacities';
import { AuthorizableActions, ResourceType } from '@/helpers/enums';
import { hasResourcePermission } from '@/helpers/userCapabilities';

export default {
  components: {
    TimeTrackingTable,
    ProjectRoughPlanning,
    ProjectAppointments,
    ProjectAppointmentCapacities,
  },
  props: {
    project: { type: Object },
  },
  computed: {
    ...mapGetters('auth', ['isGuest', 'getCurrentUser']),
    showAppointmentCapacitySlots() {
      if (this.isGuest) {
        return true;
      }
      return hasResourcePermission(this.getCurrentUser, ResourceType.APPOINTMENT_CAPACITY, [
        AuthorizableActions.LIST,
      ]);
    },
  },
  methods: {
    onAppointmentCapacityBooked() {
      this.$refs.projectAppointments?.loadTableData();
    },
  },
};
</script>
